import { IModel } from 'interfaces/model.interface'
import { ValueType } from 'interfaces/valueType.interface'

import { SortOrders } from 'enums/SortOrders'

export type PressReleasesData =
  | 'area'
  | 'disease'
  | 'authorities'
  | 'labs'
  | 'notes'
  | 'bioterrorismConsideredNotes'
  | 'isNationalNotifiableDisease'
  | 'diagnosisApproach'
  | 'interventionAvailability'
  | 'interventionType'
  | 'accessProtocol'
  | 'interventionTiming'
  | 'source'
  | 'lastUpdated'
  | 'organisations'
  | 'indications'
  | 'candidates'

const allowedAirtables = ['botulism_guideline'] as const

export const BotulismGuidelineModel: IModel<
  Record<PressReleasesData, string>,
  typeof allowedAirtables
> = {
  allowedAirtables,
  key: 'title',
  displayKey: 'disease',
  searchField: 'disease',
  detailViewType: 'Article',
  detailView: {
    link: 'sourceUrl',
    abstract: 'description',
  },
  exportDisabled: true,
  name: 'Press Releases',
  entityName: 'Press Releases',
  endpoint: 'guideline',
  defaultSortKey: 'disease',
  defaultSortOrder: SortOrders.DESC,
  noPrint: true,
  schema: {
    columns: [
      {
        key: 'area',
        label: 'Country',
        width: 200,
        type: ValueType.SINGLE,
      },
      {
        key: 'disease',
        label: 'Disease Name',
        width: 200,
        type: ValueType.MULTI,
      },
      {
        key: 'authorities',
        label: 'Governing Health Authority',
        width: 300,
        type: ValueType.MULTI,
      },
      {
        key: 'labs',
        label: 'Reference Lab',
        width: 200,
        type: ValueType.URL,
      },
      {
        key: 'notes',
        label: 'Notes',
        width: 300,
        type: ValueType.TEXT,
      },
      {
        key: 'bioterrorismConsideredNotes',
        label: 'Bioterrorism Consideration',
        width: 300,
        type: ValueType.TEXT,
      },
      {
        key: 'isNationalNotifiableDisease',
        label: 'National Notifiable Disease',
        width: 200,
        type: ValueType.BOOLEAN,
      },
      {
        key: 'diagnosisApproach',
        label: 'Diagnosis Approach',
        width: 300,
        type: ValueType.MULTI,
      },
      {
        key: 'candidates',
        label: 'Candidate Name (if Specified)',
        width: 220,
        type: ValueType.MULTI,
      },
      {
        key: 'interventionAvailability',
        label: 'Antitoxin Availability',
        width: 200,
        type: ValueType.MULTI,
      },
      {
        key: 'interventionType',
        label: 'Antitoxin Type',
        width: 300,
        type: ValueType.MULTI,
      },
      {
        key: 'accessProtocol',
        label: 'Access Protocol',
        width: 300,
        type: ValueType.MULTI,
      },
      {
        key: 'interventionTiming',
        label: 'Treatment Timing Guidance',
        width: 200,
        type: ValueType.MULTI,
      },
      {
        key: 'source',
        label: 'Source',
        width: 300,
        type: ValueType.URL,
      },
      {
        key: 'lastUpdated',
        label: 'Last Updated',
        width: 200,
        type: ValueType.DATE,
      },
      {
        key: 'organisations',
        label: 'Organisations',
        width: 300,
        type: ValueType.MULTI,
      },
      {
        key: 'indications',
        label: 'Indications',
        width: 300,
        type: ValueType.MULTI,
      },
    ],
  },
}
